import { VisuallyHidden } from './VisuallyHidden.tsx';

/**
 * The polite live region design system § 12 requires: transient results are
 * announced with both the outcome AND its human-readable value.
 *
 * `polite` and never `assertive`: an outcome is not an interruption, and the
 * practice loop holds feedback on screen for a minimum period anyway, so there
 * is time for a queued announcement to be read.
 *
 * The region must be in the document BEFORE the message changes, or the change
 * is not announced. Render it unconditionally and change `message` — never
 * mount it together with the result.
 */

interface LiveRegionProps {
  /** Empty string when there is nothing to announce. */
  message: string;
  id?: string;
}

export function LiveRegion({ message, id }: LiveRegionProps) {
  return (
    <div id={id} role="status" aria-live="polite" aria-atomic="true">
      <VisuallyHidden>{message}</VisuallyHidden>
    </div>
  );
}
